<!-- <h1>TinyMCE 5 Angular Demo</h1> -->
<!-- <editor
  [init]="{
    height: 500,
    menu: {
        file: { title: 'File', items: 'newdocument restoredraft | preview | export print | deleteallconversations' },
        edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
        view: { title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments' },
        insert: { title: 'Insert', items: 'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime' },
        format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat' },
        tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount' },
        table: { title: 'Table', items: 'inserttable | cell row column | advtablesort | tableprops deletetable' },
        help: { title: 'Help', items: 'help' }
      },
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help wordcount'
    ],
    toolbar:
      'undo redo | formatselect | bold italic backcolor | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | removeformat | help |Advanced List|Anchor|Autolink|Autoresize|Autosave|Character Map|Code|Code Sample|Directionality|Emoticons|Full Screen'
  }"
></editor> -->
<div class="row">
    <div class="col-12" [ngClass]="{'my-disable':ALLAboveNoneAboveChoiceflag}">
        <editor
        [id]="editorId"
        *ngIf="RTEFlag=='AnswerChoiceNote'||RTEFlag=='AnswerChoice'||RTEFlag=='QuestionBody'"
        [init]="options"
        [(ngModel)]='QuestionBodyget'
        (ngModelChange)="GetContent()"

        ></editor>
        <editor
        [id]="editorId2"
        [init]="options1"
        [(ngModel)]='QuestionBodyget'
        (ngModelChange)="GetContent()"
        *ngIf="RTEFlag=='Submit for review'"
        ></editor>
        <editor
        [id]="editorId3"
        [init]="options2"
        [(ngModel)]='QuestionBodyget'
        (ngModelChange)="GetContent()"
        *ngIf="RTEFlag=='Commentbox'"
        ></editor>
    </div>

</div>

  <!-- <textarea name="content" style="width:100%"></textarea>
  <script>
    tinymce.init({
      plugins: [
      "eqneditor advlist autolink lists link image charmap print preview anchor",
      "searchreplace visualblocks code fullscreen",
      "insertdatetime media table contextmenu paste" ],
      toolbar: "undo redo | eqneditor link image | styleselect | bold italic | bullist numlist outdent indent	",
      selector : "textarea"
      });
    </script> -->
